import { computed, inject, ref, watch } from 'vue';
import {
  MERIDIA_TABS_ACTIVE_VALUE,
  MERIDIA_TAB_PANELS_KEEP_ALIVE,
  MERIDIA_TAB_PANELS_ANIMATED,
  MERIDIA_TABS_TRANSITION_DIRECTION,
} from 'src/design_system/components/tab/types';

export function useTabPanelAnimation(props: { value: string | number; keepAlive?: boolean | null }) {
  const activeValue = inject(MERIDIA_TABS_ACTIVE_VALUE, undefined);
  const keepAliveRef = inject(MERIDIA_TAB_PANELS_KEEP_ALIVE, undefined);
  const animatedRef = inject(MERIDIA_TAB_PANELS_ANIMATED, undefined);
  const transitionDirectionRef = inject(MERIDIA_TABS_TRANSITION_DIRECTION, undefined);

  const shouldKeepAlive = computed(() =>
    props.keepAlive != null ? props.keepAlive : (keepAliveRef?.value ?? false)
  );

  const isActive = computed(() =>
    activeValue?.value != null && activeValue.value === props.value
  );

  const animationClass = ref('');

  watch(isActive, (newValue) => {
    if (!newValue) {
      animationClass.value = '';
      return;
    }
    if (!animatedRef?.value) return;
    const direction = transitionDirectionRef?.value;
    if (direction === 'forward') {
      animationClass.value = 'tab-enter-from-right';
    } else if (direction === 'backward') {
      animationClass.value = 'tab-enter-from-left';
    } else {
      animationClass.value = 'tab-enter-fade';
    }
  });

  return { isActive, shouldKeepAlive, animationClass };
}
